// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"3cd06f25","354":"1cc74234","875":"3918e97a"}[chunkId] + ".chunk.js";
};